import React from 'react';
import { Image, ImageSourcePropType, ImageStyle, View } from 'react-native';

import { makeStyles } from '@providers/Theme';
import {
  TypographyProps as ITypographyProps,
  Typography,
} from '@components/Typography';

export type ReceiptRowProps = {
  accessibilityLabel?: string;
  testID: string;
  name: string | React.ReactNode;
  value: string;
  title?: string | React.ReactNode;
  image?: ImageSourcePropType;
  TypographyProps?: Partial<Omit<ITypographyProps, 'children'>>;
  imgHeight?: number;
};

type ReceiptRowStylesProps = {
  imgHeight?: number;
};

const useStyles = makeStyles<ReceiptRowStylesProps>((theme) => ({
  field: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    on: {
      xs: {
        flexDirection: 'column',
        paddingBottom: theme.spacing(1),
      },
      md: {
        flexDirection: 'row',
        paddingBottom: theme.spacing(0),
      },
    },
    flex: 1,
  },
  name: {
    paddingRight: theme.spacing(0.5),
  },
  value: {
    flex: 1,
  },
  content: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: theme.spacing(0.5),
  },
  img: (props) => ({
    width: 24,
    height: props.imgHeight || 24,
    marginRight: theme.spacing(1),
  }),
}));

export const ReceiptRow: React.FC<ReceiptRowProps> = ({
  accessibilityLabel,
  testID,
  name,
  value,
  image,
  title,
  TypographyProps,
  imgHeight,
}) => {
  const styles = useStyles({ imgHeight });

  return (
    <View style={styles.field} testID={testID} accessibilityLabel={accessibilityLabel}>
      <View style={styles.wrapper}>
        {title && (
          <Typography
            testID="title"
            weight="extraBold"
            size={{ xs: 'sm', lg: 'md' }}
            style={styles.name}
            variant="primary"
            {...TypographyProps}>
            {title}:
          </Typography>
        )}
        <Typography
          testID="name"
          weight="extraBold"
          size={{ xs: 'sm', lg: 'md' }}
          style={styles.name}
          variant="primary"
          {...TypographyProps}>
          {name}
        </Typography>
      </View>

      <View testID="value" style={styles.value}>
        <View testID="content" style={styles.content}>
          {image && <Image source={image} style={styles.img as ImageStyle} />}
          <Typography
            testID="price"
            weight="extraBold"
            size={{ xs: 'sm', lg: 'md' }}
            variant="primary"
            {...TypographyProps}>
            {value}
          </Typography>
        </View>
      </View>
    </View>
  );
};
